/**************
 Product Swiper
 **************/

// options for all swipers
const swiperOptions = {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoHeight: true,
    zoom: {
        maxRatio: 2,
    },
    on: {
        slideChange: function () {
            // pause all videos
            document.querySelectorAll(".productBottleVisualSwiperSlide video").forEach(element => {
                element.pause();
            });
        }
    }
};

// setup single swiper
const productSwiper = new Swiper(document.querySelector(".productBottleVisualSwiper"), swiperOptions);

// change slide on thumbnail click
document.querySelectorAll(".productBottleVisualThumbsSlide").forEach(element => {
    element.addEventListener("click", function () {
        // change slide
        productSwiper.slideTo(this.dataset.index - 1);
    });
});

// update the thumbnail active class
productSwiper.on('slideChange', function () {
    document.querySelector(".productBottleVisualThumbsSlide.active")?.classList.remove("active");
    document.querySelectorAll(".productBottleVisualThumbsSlide")[this.realIndex].classList.add("active");
});

// play video on slide play click
document.querySelectorAll(".productBottleVisualSwiperSlide").forEach(element => {
    element.addEventListener("click", function () {
        // get video
        const video = this.closest(".productBottleVisualSwiperSlide").querySelector("video");

        if (!video) return;

        // remove play button if it hasn't already been removed
        this.querySelector(".productBottleVisualSwiperSlidePlay")?.remove();

        // show controls
        video.controls = true;

        // play video
        video.play();
    });
});

/****************
 Update Display
 ***************/

// update active variant
function updateProduct(soldOut = false) {
    // update prices
    document.querySelector(".productBottlePriceActual").textContent = price(activeVariant.price * quantity);
    activeVariant.compare_at_price > activeVariant.price
        ? document.querySelector(".productBottlePriceCompare").textContent = price(activeVariant.compare_at_price * quantity)
        : document.querySelector(".productBottlePriceCompare").textContent = "";

    // enable primary atc
    document.querySelector("#productBottleCheckoutATC").disabled = false;

    // check if the variant is in stock
    // if (activeVariant.available) {
    if (activeVariant.available && !soldOut) {
        document.querySelector("#productBottleCheckoutATC").classList.remove("soldOut");
        document.querySelector("#productBottleCheckoutATC").textContent = "Add To Cart";
    } else {
        document.querySelector("#productBottleCheckoutATC").classList.add("soldOut");
        document.querySelector("#productBottleCheckoutATC").textContent = "Sold Out - Notify Me When Available";
    }
}

/*********
 Quantity
 *********/

// quantity base
let quantity = 1;
document.querySelectorAll('.productBottleCheckoutQuantityButton')?.forEach(button => {
    button.addEventListener('click', function () {
        if (this.classList.contains('productBottleCheckoutLess')) {
            if (quantity === 1) return;
            quantity--;
        }
        if (this.classList.contains('productBottleCheckoutMore')) {
            quantity++;
        }
        // update the display and input
        document.querySelector('.productBottleCheckoutQuantityText').textContent = String(quantity);
        document.querySelector('.productBottleCheckoutQuantityInput').value = quantity;
        updateProduct();
    })
})

/***********
 Product ATC
 ***********/

document.querySelector("#productBottleCheckoutATC")?.addEventListener("click", async function () {
    // check for out of stock
    if (this.classList.contains("soldOut")) {
        // check email
        let {value: email} = await Swal.fire({
            title: `${product.title} / ${activeVariant.title}`,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        await sendKlaviyoBackInStockRequest(email, activeVariant.id);

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    let formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
        }]
    };

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});

// check if discount code is present
if (Cookies.get("discount_code")) {
    // set the discount code text
    document.querySelector("#productBottleCouponField").textContent = `${Cookies.get("discount_code").toUpperCase()} applied at checkout`;

    // show the discount code element
    document.querySelector("#productBottleCouponField").classList.add("active");
}